// extracted by mini-css-extract-plugin
export default {"headerWrap":"Header_headerWrap__dDVeF","joinModalWrap":"Header_joinModalWrap__B3KyH","closeBtn":"Header_closeBtn__qdvPn"};